export interface UserList {
  id?: string
  name: string
  gmail: string
  sex: string
  dob: string
  age: string
  position: string
  typeOfPostion: string
  avatar: string
}
export interface ListActivityType {
  id?: string
  avatar: string
  email: string
  name: string
  typeOfPostion: string
  blTask: string
  taskIp: string
  taskIr: string
}
export const ListActivityData: ListActivityType[] = [
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
  {
    id: '1',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
    email: 'evanyates@gmail.com',
    name: 'Shawn Stone',
    typeOfPostion: 'Middle',
    blTask: '0',
    taskIp: '16',
    taskIr: '6',
  },
]

export const DataUser: UserList[] = [
  {
    id: '1',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '2',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.30808-1/430222428_423353630362442_8728284729764943063_n.jpg?stp=dst-jpg_p320x320&_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=PMqJhDTdLnwAX_0wJqt&_nc_ht=scontent.fsgn5-10.fna&oh=00_AfBqA5ztryEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '3',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '4',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '5',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
  {
    id: '6',
    name: 'Evan Yates',
    gmail: 'evanyates@gmail.com',
    sex: 'Male',
    dob: 'Apr 12, 1995',
    age: '25',
    position: 'UI/UX Designer',
    typeOfPostion: 'Middle',
    avatar:
      'https://scontent.fsgn5-10.fna.fbcdn.net/v/t39.3080…yEtHk7_FVPCl40b1YE8BtGg2hSLHo4cdagdtw&oe=65F1C0B0',
  },
]
